<template>
  <div>
    <beautiful-chat
      style="position:relative;height:800px"
      :participants="chatInfo.participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :open="openChat"
      :showEmoji="true"
      :showFile="true"
      :showTypingIndicator="showTypingIndicator"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :messageStyling="messageStyling"
    />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      messageList: [],
      position: -1,
      participants: [],
      timers: [],
      simulationId: 0,
      titleImageUrl:
        "https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png",
      newMessagesCount: 0,
      isChatOpen: true, // to determine whether the chat window should be open or closed
      showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: "#182952",
          text: "#ecf0f1"
        },
        launcher: {
          bg: "#182952"
        },
        messageList: {
          bg: "#182952"
        },
        sentMessage: {
          bg: "#ecf0f1",
          text: "black"
        },
        receivedMessage: {
          bg: "#ecf0f1",
          text: "black"
        },
        userInput: {
          bg: "#ecf0f1",
          text: "black"
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true // enables *bold* /emph/ _underline_ and such (more info at github.com/mattmezza/msgdown)
    };
  },
  props: {
    commentsData: {
      default: function() {
        return {};
      },
      type: Object
    },
    videoTime: {
      type: Number,
      default: null
    },
    paused: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chatInfo() {
      let messageList = [];
      let participants = {};
      for (let comment of this.commentsData.comments) {
        messageList.push({
          type: "text",
          author: comment.display_name,
          data: {
            text: comment.body,
            meta: comment.content_offset_seconds + ""
          }
        });
        participants[comment.display_name] = {
          id: comment.display_name,
          name: comment.display_name
          // imageUrl: "https://avatars3.githubusercontent.com/u/1915989?s=230&v=4"
        };
      }
      participants = Object.values(participants);
      return { messageList: messageList, participants: participants };
    }
  },
  methods: {
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1;
        this.onMessageWasSent({
          author: "support",
          type: "text",
          data: { text }
        });
      }
    },
    onMessageWasSent(message) {
      // called when the user sends a message
      this.messageList = [...this.messageList, message];
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      // this.isChatOpen = false;
    },
    scheduleNextChat(position, timestamp, simulationId) {
      let self = this;
      let comment = self.commentsData.comments[position];

      setTimeout(() => {
        if (
          simulationId !== self.simulationId ||
          self.paused ||
          position >= self.commentsData.comments.length
        ) {
          return;
        }

        let emoji = comment.classification["hate"] > 0.5 ? " 🤬 " : "";
        this.messageList.push({
          type: "text",
          author: comment.display_name,
          data: {
            text: (emoji + comment.body + emoji).trim(),
            meta: comment.content_offset_seconds
          }
        });
        // schedule next message
        self.scheduleNextChat(
          position + 1,
          comment.content_offset_seconds,
          simulationId
        );
      }, 1000 * (comment.content_offset_seconds - timestamp));
    },
    simulateChat(timestamp) {
      this.messageList = [];
      this.timers = [];
      this.participants = [];
      this.simulationId += 1;
      console.log("simulating chat from " + timestamp);
      for (var i = 0; i < this.commentsData.comments.length; i++) {
        const comment = this.commentsData.comments[i];
        if (comment.content_offset_seconds >= timestamp) {
          break;
        }
      }
      this.scheduleNextChat(i, timestamp, this.simulationId);
    }
  },
  watch: {
    videoTime(newvideoTime) {
      if (newvideoTime !== null) {
        this.simulateChat(newvideoTime);
      }
    }
  },
  mounted() {
    if (this.videoTime !== null) {
      this.simulateChat(this.videoTime);
    }
  }
};
</script>

<style >
td {
  color: white !important;
}
.sc-header--close-button {
  display: none;
}
.sc-chat-window {
  background-color: #182952 !important;
  top: 0;
  max-height: 800px !important;
  height: 800px !important;
  position: relative !important;
  right: 0 !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
  width: 100% !important;
}
.sc-message--text p {
  margin-block-end: 0px;
}
.sc-message--text {
  font-size: 14px !important;
  padding: 5px !important;
}
.sc-message--meta {
  font-size: 8px !important;
  color: grey !important;
}
.sc-user-input {
  visibility: hidden;
  min-height: 0 !important;
  height: 0 !important;
}
.sc-launcher {
  visibility: hidden;
  min-height: 0 !important;
  height: 0 !important;
}
.sc-message--avatar {
  background-color: #719bee !important;
  background-image: none !important;
}
</style>
